import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout pai de /dashboard/sessoes/* — apenas repassa o Outlet pras filhas
 * (index = lista, $id = detalhe, recorrencias, recorrencia/nova).
 */
export const Route = createFileRoute('/dashboard/sessoes')({ component: () => <Outlet /> });
